<template>
   
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              <div v-if="editUserClient.id">
                <h3>Mitarbeiter/Abbteilung/Thema bearbeiten</h3>
                 <small class="text-right">Link: {intern::{{editUserClient.id}}::{{editUserClient.lastName}} {{editUserClient.department}} {{userClient.function}}}</small>
              </div>
              <h3 v-else>Neuen 'Mitarbeiter/Abbteilung/Thema anlegen</h3>
               
               
              <div v-if="false">
                <!-- DEBUGG -->
                idCompany: {{editUserClient.idCompany}}
                idUser: {{editUserClient.idUserClient}}
              </div>
              
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              <form @keyup.esc="$emit('cancel', userClient)" @submit.prevent="onSubmit"  :id="_uid">

                <div class="form-group">
                  <label for="userclient-art">Art:</label>
                  <select id="userclient-art" v-focus required class="form-control" v-model="editUserClient.idSex">
                    <option v-for="option in UserConf.ART" 
                      :value="option.VALUE">
                      {{ option.TEXT }}
                    </option>
                  </select>
                </div>

                <div v-show="editUserClient.idSex < 3" class="form-group">
                  <label for="userclient-title">Titel:</label>
                  <select id="userclient-title" class="form-control" v-model="editUserClient.idPertitel">
                    <option v-for="option in UserConf.PERTITEL" 
                      :value="option.VALUE">
                      {{ option.TEXT }}
                    </option>
                  </select>
                </div>

                <div class="form-group">
                  <label v-if="editUserClient.idSex < 3" for="userclient-firstname">Vorname:</label>
                  <label v-else for="userclient-firstname">Beschreibung:</label>
                  <input type="text" class="form-control" id="userclient-firstname" placeholder="" v-model="editUserClient.firstName">
                </div>
                
                <div class="form-group">
                  <label v-if="editUserClient.idSex < 3" for="userclient-lastname">Nachname:</label>
                  <label v-else for="userclient-lastname">Beschreibung:</label>
                  <input required type="text" class="form-control" id="userclient-lastname" placeholder="" v-model="editUserClient.lastName">
                </div>
                
                
                <div class="form-group">
                  <label for="userclient-department">Abteilung:</label>
                  <input type="text" class="form-control" id="userclient-department" placeholder="" v-model="editUserClient.department">
                </div>

                <div class="form-group">
                  <label for="userclient-function">Funktion:</label>
                  <input type="text" class="form-control" id="userclient-function" placeholder="" v-model="editUserClient.function">
                </div>

                <div class="form-group">
                  <label for="userclient-room">Zimmer/Ort::</label>
                  <input type="text" class="form-control" id="userclient-room" placeholder="" v-model="editUserClient.room">
                </div>

               <div class="form-group">
                  <label for="userclient-calltemplate">Vorlage:</label>
                  <textarea class="form-control" id="userclient-calltemplate" rows="6" placeholder=""  v-model="editUserClient.calltemplate"></textarea>
                </div>

                
              </form>
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
              <button type="submit"
                :form="_uid"
                class="btn btn-primary">
                Speichern
              </button>

              <button type="" 
                class="btn btn-default"
                @click="$emit('cancel', userClient)">
                Abbrechen
              </button>
<!--  
              <button type="" 
                v-if="editUserClient.id" 
                class="btn btn-danger"   
                @click="$emit('remove', userClient)">
                Löschen
              </button>               
-->               
            </slot>
          </div>
          
        </div>
      </div>
    </div>
  </transition>

</template>



<script>

//import DateTime from './helper/datetime.vue'
import * as UserConf from './common/user.conf'
import moment from 'moment'

export default {
  
  
  components: {
    //'cc-datetime': DateTime,
  },  

  
  data () {
    return {
      UserConf: UserConf,
      editUserClient: JSON.parse(JSON.stringify(this.userClient)), 
    }
  },
  
  
  props: {
    idCompanyClient: 0,
    userClient: {
      type: Object,
      default:  function () {
        return {
          userName: "",
          password: "",
          idStatus: "",
          language: "",
          session: "",
          authorisation: "210",
          counter: "",
          personnelNumber: "0",
          department: "",
          room: "",
          calltemplate: "",
          id: "",
          idCompany: this.idCompanyClient,
          idCompanyContact: this.idCompanyClient,
          lastName: "",
          firstName: "",
          info: "",
          idSex: "",
          idPertitel: "0",
          street: "",
          streetNumber: "",
          zipCode: "",
          city: "",
          idCountry: "",
          function: "",
          customerNumber: "",
          validity: "",
          datetimeRegister:"0000-00-00 00:00:00",
          datetimeUpdate: "0000-00-00 00:00:00",
          datetimeBegin:moment().format('YYYY-MM-DD HH:mm:ss'),
          datetimeEnd:"2029-12-31 00:00:00",
        };
      },
    }
  },
  
  
  created: function () {
  },
  
  computed: {
  },  
  
  
  methods: {
    
    

    onSubmit: function () {
      if(_.isEqual(this.userClient, this.editUserClient)){
        // keine Änderung, speichern nicht notwendig
        this.$emit('cancel', this.userClient)
      }else{
        // speichern
        this.$emit('save', this.editUserClient)
      }
    },
    
  },
}
  
</script>

<style scoped>
  
  
.tag {
  font-size: 14px;
  padding: .3em .4em .4em;
  margin: 0 .1em;
}
.tag a {
  color: #bbb;
  cursor: pointer;
  opacity: 0.6;
}
.tag a:hover {
  opacity: 1.0
}
.tag .remove {
  vertical-align: bottom;
  top: 0;
}
.tag a {
  margin: 0 0 0 .3em;
}
.tag a .glyphicon-white {
  color: #fff;
  margin-bottom: 2px;
} 
  .label-default{
    background-color: #bbb;    
  }  
  
  

 .modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-container {
  width: 80vh;
  /*margin: 0px auto;*/
  margin-left: 15%;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
  font-family: Helvetica, Arial, sans-serif;
}

.modal-header h3 {
  margin-top: 0;
}

.modal-body {
  overflow: scroll;
  height:50vh;
  margin: 20px 0;
  padding-bottom: 50px;
}

.modal-footer {
  margin-top: 30px;
  padding-top: 30px;
  border-top: 1px solid lightgray;
  text-align: right;
}

  .modal-default-button {
  float: right;
}

/*
 * The following styles are auto-applied to elements with
 * transition="modal" when their visibility is toggled
 * by Vue.js.
 *
 * You can easily play with the modal transition by editing
 * these styles.
 */

.modal-enter {
  opacity: 0;
}

.modal-leave-active {
  opacity: 0;
}

.modal-enter .modal-container,
.modal-leave-active .modal-container {
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

  
input:invalid {
  border: 1px solid red;
}  
</style>



// WEBPACK FOOTER //
// UserClientModal.vue?9bb21cac